import { useQuery } from "@tanstack/react-query";
import { CustomersAPI } from "api";

const fetchCustomer = () => {
  return CustomersAPI.get();
};
export const useFetchCustomers = () => {
  return useQuery({
    queryKey: ["customers"],
    queryFn: fetchCustomer,
  });
};
